import * as React from 'react'
import styles from './ctaBanner-style.css'
import Heading from '../Heading/Heading'
import Paragraph from '../Paragraph/Paragraph'
import Image from '../Image/Image'
import Button from '../Button/Button'
import type { CtaBannerViewModel } from '../../view-models/CtaBannerViewModel'
type Props = CtaBannerViewModel

function CtaBanner({ image, heading, text, cta }: Props) {
  const event = cta ? 'cta' : ''
  const eventData = cta && cta.link ? cta.link.label : ''
  const eventMeta = {
    event,
    eventData,
  }

  return (
    <div className={`${styles.ctaBanner} ${!image ? styles.noImage : ''}`}>
      <div className={styles.textWrapper}>
        {heading && (
          <Heading level={2} className={styles.ctaTitle}>
            {heading}
          </Heading>
        )}
        {text && (
          <Paragraph weight="light" marginBottom="large" className={styles.ctaText}>
            {text}
          </Paragraph>
        )}
        {cta && (
          <Button
            {...cta.link}
            version={cta.version}
            darkBg
            eventMeta={eventMeta}
            icon={cta.icon}
          />
        )}
      </div>
      {image && (
        <div className={styles.imageWrapper}>
          <Image {...image} contain />
        </div>
      )}
    </div>
  )
}

CtaBanner.displayName = 'CtaBanner'
CtaBanner.defaultProps = {}
export default CtaBanner